import type { ReadSearchApiArg } from 'lib-search-types';
import { filterFieldCatalogue, filterOperatorCatalogue } from 'lib-search-ui';
import { memo, useMemo } from 'react';

import { SearchScopeFilter } from 'components/search';

import { useSearchQuickFilter } from '../../utils/useSearchQuickFilter';

export const SearchContactQuickFilter = memo(
  function SearchContactQuickFilter(): JSX.Element {
    const { condition, handleChange } = useSearchQuickFilter('requested_by');

    const initialArg: ReadSearchApiArg<'users'> = useMemo(
      () => ({
        scope: 'users',
        sortBy: { field: 'display_name', order: 'asc' },
        filters: {
          strategy: 'all',
          filters: [
            {
              field: 'user_type',
              operator: 'is_one',
              values: [{ value: 'contact' }],
            },
          ],
        },
      }),
      [],
    );

    return (
      <SearchScopeFilter
        scope="users"
        placeholder="Search contacts..."
        operators={filterOperatorCatalogue.conversations.requested_by.operators}
        defaultOperator={
          filterOperatorCatalogue.conversations.requested_by.defaultOperator
        }
        selectedValues={condition?.values}
        selectedOperator={condition?.operator}
        initialArg={initialArg}
        onChange={handleChange}
      >
        {filterFieldCatalogue.conversations.requested_by.label}
      </SearchScopeFilter>
    );
  },
);
